<template>
  <div class="incomeHomeServiceLabor">
    <div class="filters">
      <!-- 添加输入框和选择框、提交按钮 -->
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="this.$store.getters.gardenId === 0">
          <el-select class="select" v-model="village" :placeholder="$t('lang.lab_selectCommunity')">
            <el-option key :label="$t('lang.villageall')" value></el-option>
            <el-option
              v-for="(item,index) in villagetypes"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="seachInput" v-model="keyword" :placeholder="$t('lang.lab_name')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        <!-- <el-form-item>
          <el-input class="seachInput" v-model="je" placeholder="已发放金额"></el-input>
        </el-form-item>
        <el-button type="primary" @click="yffje()">保存</el-button> -->
      </el-form>
      <!-- 添加表格 -->
    </div>
    <el-card>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
      <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="incomeHomeServiceLaborcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 工号 -->
        <el-table-column prop="StaffId" :label="$t('lang.lab_staffId')" width="100px"></el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="IdNo" :label="$t('lang.lab_name')"></el-table-column>
        <!-- 待发放金额 -->
        <!-- <el-table-column prop="waitLabor" sortable :label="$t('lang.lab_waitLabor')"></el-table-column> -->
        <!-- 所有劳务所得 -->
        <el-table-column prop="sumLabor" sortable :label="$t('lang.lab_sumLabor')"></el-table-column>
        <!-- 查看详情 -->
        <el-table-column :label="$t('lang.btn_lookfordetail')" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="details(scope.row.StaffId)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:居家服务劳动所得
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-04
 */
export default {
  name:'/manage/main.serviceCommissionList',
  data() {
    // 表格内容默认数据
    return {
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      incomeHomeServiceLaborcheckbox: true, // 是否隐藏复选框
      tableData: [], // 表单数据
      multipleSelection: [], // 多选框
      villagetypes: [], // 小区
      keyword: '', // 姓名
      je: 0,
      selectArr: [],
      village: '' // 选择小区
    }
  },
  // 初始化
  created() {
    this.gardens()
    this.topics()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
      let selectArr = []
        val.forEach(element => {
          selectArr.push({ id: element.StaffId, createPerson: element.createPerson })
        })
        this.selectArr = selectArr
        console.log(selectArr)
    },
    // 进入页面后默认显示
    topics() {
      let loading = this.$loading()
      this.$get(
        `/getServiceCommission?pageNo=${this.pageNo}&pageSize=${this.pageSize}&keyword=${this.keyword}&gardenId=${this.village}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 选小区
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.villagetypes = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击查看详情
    details(staffId) {
      this.$router.push({
        name: 'incomeHomeServiceLaborDetails',
        query: { id: staffId }
      })
    },
    // 点击提交
    submit() {
      this.pageNo = 1
      this.topics()
    },
    yffje() {
      if (this.selectArr.length > 0) {
        let loading = this.$loading()
        this.$confirm(
                '是否已发放金额到指定物业人员？',
                this.$i18n.t('lang.lab_prompt'), {
                  confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                  cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                  type: 'warning'
                }
            )
            .then(() => {
              for (let i = 0; i < this.selectArr.length; i++) {
                  
              }              
            })
            .catch(() => {
              loading.close()
            })
      } else {
        this.$message.error('请至少选择一个物业人员！')
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang= 'scss' scoped>
</style>